import { CartUrgencyDS } from '@src/components/blocks/cart-urgency-ds'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { CartUrgencyLegacy } from './cart-urgency-legacy'

export interface CartUrgencyProps {
  className?: string
}

export const useCartUrgencyExperiment = (): boolean => {
  const { experimentBucket: cartUrgencyBucket, init: initCartUrgency } = useStatsigExperiment(
    STATSIG_EXPERIMENTS.CART_URGENCY,
  )
  const isCartUrgencyEnabled =
    initCartUrgency && cartUrgencyBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CART_URGENCY].buckets?.Show

  return isCartUrgencyEnabled
}

export const CartUrgency = ({ className }: CartUrgencyProps) => {
  if (shouldUseDesignSystem()) {
    return <CartUrgencyDS className={className} />
  }

  return <CartUrgencyLegacy className={className} />
}
